export function SettingLineIcon({
  className,
}: {
  className?: string;
}) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g clip-path="url(#clip0_446_4247)">
        <circle cx="10.0001" cy="9.99999" r="2.32824" stroke="#101828" stroke-width="1.67" />
        <path d="M13.4054 3.26846C13.7031 3.26846 13.9782 3.42729 14.1271 3.68513L17.5324 9.58331C17.6813 9.84114 17.6813 10.1588 17.5324 10.4166L14.1271 16.3148C13.9782 16.5727 13.7031 16.7315 13.4054 16.7315L6.59479 16.7315C6.29706 16.7315 6.02196 16.5727 5.8731 16.3148L2.46778 10.4166C2.31892 10.1588 2.31892 9.84114 2.46778 9.58331L5.8731 3.68513C6.02196 3.42729 6.29706 3.26846 6.59479 3.26846L13.4054 3.26846Z" stroke="#101828" stroke-width="1.67" />
      </g>
      <defs>
        <clipPath id="clip0_446_4247">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

SettingLineIcon.displayName = 'SettingLineIcon';
